import { useContext, useEffect, useState } from "react";

import DashboardContext from "../../context/DashboardContext";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function EstablishmentCard({
  id,
  name,
  category,
  cover,
  isDisabled,
  handler,
  selectedId,
  type,
}) {
  const [establishmentSelectedId, setEstablishmentSelectedId] =
    useState(selectedId);

  const { customPrimaryColor } = useContext(DashboardContext);

  useEffect(() => {
    setEstablishmentSelectedId(selectedId);
  }, [selectedId]);

  return (
    <Button
      name={id}
      onClick={handler}
      sx={{
        alignItems: "center",
        backgroundColor: "#F5F5F5",
        border: `${
          establishmentSelectedId === id && `3px solid ${customPrimaryColor}`
        }`,
        borderRadius: "30px",
        boxShadow: "0px 0px 10px 0px rgb(88 88 88 / 30%)",
        display: "flex",
        flexDirection: "column",
        height: "130px",
        margin: "auto",
        overflow: "hidden",
        px: 1,
        py: 0,
        textAlign: "center",
        width: "130px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          backgroundImage: `url(${cover})`,
          backgroundClip: "border-box",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          boxShadow: "0px 0px 10px 0px rgb(88 88 88 / 10%)",
          filter: `${isDisabled && "grayscale(100%) opacity(50%)"}`,
          height: "80px",
          width: "130px",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          justifyContent: "center",
        }}
      >
        <Typography
          color={(isDisabled || type) && "#767676"}
          fontWeight={600}
          title={name}
          variant="caption"
        >
          {name.length > 10 ? `${name.slice(0, 10)}...` : name}
        </Typography>
        <Typography
          color={
            isDisabled
              ? "#767676"
              : type === "pedency"
              ? "#f1c40f"
              : type === "approved"
              ? "#07bc0c"
              : type === "disapproved"
              ? "#e74c3c"
              : null
          }
          title={category}
          variant="caption"
        >
          {category.length > 10 ? `${category.slice(0, 10)}...` : category}
        </Typography>
      </Box>
    </Button>
  );
}
